<template>
  <v-dialog
    v-model="show"
    transition="dialog-bottom-transition"
    max-width="500px"
    persistent
  >
   <v-card class="pa-5" min-width="400">
    <v-card-text>
      <h4 class="text-h6">{{title}}</h4>
      <v-form ref="preferenceForm">
        <v-text-field
          v-model="label"
          label="Preference Name"
          :rules="[rules.required]"
        ></v-text-field>
        <v-select
          label="Preference Type"
          v-model="type"
          :items="types"
          :rules="[rules.required]"
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn @click="close" color="kbGold" class="white--text">
        {{'Close'}}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn @click="submit" color="kbGold" class="white--text">
        {{isEdit ? 'Edit Preference' : 'Create Preference' }}
      </v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</template>
<script>
import rules from '@/libs/rules'
export default {
  data: () => ({
    label: '',
    type: ''
  }),
  props: {
    value: Boolean,
    title: {
      type: String,
      default: 'Create Preference'
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    selectedPreference: {
      type: Object,
      required: true
    },
    types: {
      type: Array,
      require: true
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    rules () {
      return rules
    }
  },
  methods: {
    clear () {
      this.label = ''
      this.type = ''
    },
    resetValidations () {
      this.$refs.preferenceForm.resetValidation()
    },
    submit () {
      if (!this.$refs.preferenceForm.validate()) return
      const preference = {
        label: this.label,
        type: this.type
      }
      if (this.isEdit) {
        const { id } = this.selectedPreference
        this.$emit('editPreference', preference, id)
      } else {
        this.$emit('createPreference', preference)
      }
      this.clear()
      this.resetValidations()
      this.show = false
    },
    close () {
      this.clear()
      this.show = false
    }
  },
  watch: {
    isEdit (value) {
      if (value === true) {
        this.label = this.selectedPreference.label
        this.type = this.selectedPreference.type
      }
    }
  }
}
</script>
